import { render, staticRenderFns } from "./ClaimApprovedTable.vue?vue&type=template&id=0bb42c0d"
import script from "./ClaimApprovedTable.vue?vue&type=script&lang=js"
export * from "./ClaimApprovedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports